import { render, staticRenderFns } from "./ImgZoomComponent.vue?vue&type=template&id=87cb40e0"
import script from "./ImgZoomComponent.vue?vue&type=script&lang=js"
export * from "./ImgZoomComponent.vue?vue&type=script&lang=js"
import style0 from "./ImgZoomComponent.vue?vue&type=style&index=0&id=87cb40e0&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports